// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"contactStyles-module--bodyWrapper--2c4Uu","linksWrapper":"contactStyles-module--linksWrapper--yORgH"};